import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { FC } from "react";

import { OrderImage } from "@/components/Account/OrderList/Order/OrderItem/partials/orderImage.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { AdditionalServicesComponent } from "@/components/Order/shared/OrderItem/AdditionalServices/additionalServices.component";
import { ArticleConfigurationComponent } from "@/components/Order/shared/OrderItem/ArticleConfiguration/articleConfiguration.component";
import { PriceComponent } from "@/components/Order/shared/OrderItem/Price/price.component";
import { QuantityComponent } from "@/components/Order/shared/OrderItem/Quantity/quantity.component";
import { ReferenceComponent } from "@/components/Order/shared/OrderItem/Reference/reference.component";
import {
    ConfigurableProductRenditions,
    OrderDetailItemRenditions
} from "@/components/Product/ProductImage/mappedRenditions";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

import { HeaderComponent } from "../../shared/OrderItem/Header/header.component";

export type DeliveryPromiseComponentProps = {
    item: OrderItemModel;
    deliveryType: DeliveryType;
};

type Props = {
    item: OrderItemModel;
    additionalServiceTooltip?: TooltipType;
    deliveryType: DeliveryType;
    productTitleLink: boolean;
    DeliveryPromiseComponent: FC<DeliveryPromiseComponentProps>;
};

const _OrderItem = ({
    item,
    additionalServiceTooltip,
    deliveryType,
    productTitleLink,
    DeliveryPromiseComponent
}: Props) => {
    const { breakpoints } = useBreakpoint();

    return (
        <Row className={"my-2 align-items-center"}>
            <Col
                xs={3}
                sm={2}
                className={"align-self-start"}
            >
                <OrderImage
                    medias={item.medias}
                    title={item.title}
                    url={item.url}
                    imageRenditions={
                        item.articleConfiguration
                            ? ConfigurableProductRenditions
                            : OrderDetailItemRenditions
                    }
                />
            </Col>
            <Col
                xs={9}
                md={5}
            >
                <HeaderComponent
                    item={item}
                    link={productTitleLink}
                />
                <ArticleConfigurationComponent item={item} />
                <ReferenceComponent item={item} />

                {!breakpoints.md && (
                    <>
                        <QuantityComponent quantity={item.quantity} />
                        <DeliveryPromiseComponent
                            item={item}
                            deliveryType={deliveryType}
                        />
                    </>
                )}
            </Col>
            {breakpoints.md && (
                <Col md={3}>
                    <QuantityComponent quantity={item.quantity} />
                    <DeliveryPromiseComponent
                        item={item}
                        deliveryType={deliveryType}
                    />
                </Col>
            )}
            <Col
                xs={12}
                md={2}
                className={"text-right pt-1 pb-3 py-md-0"}
            >
                <PriceComponent item={item} />
            </Col>
            <AdditionalServicesComponent
                additionalServices={item.additionalServices ?? []}
                additionalServiceTooltip={additionalServiceTooltip}
            />
        </Row>
    );
};

export const OrderItem = withBreakpoints(_OrderItem);
